export const gtmEventTypes = {
  CLICK_SUB_NAV_LINK: 'FED-OFFERS-001',
  EXPAND_ACCORDION: 'FED-OFFERS-002',
  COLLAPSE_ACCORDION: 'FED-OFFERS-003',
  CLICK_CTA: 'FED-OFFERS-004',
  CLICK_RECOMMENDED_CONTENT: 'FED-OFFERS_005',
}

export const gtmEvents = {
  [gtmEventTypes.CLICK_SUB_NAV_LINK]: ({itemName}) => ({
    type: gtmEventTypes.CLICK_SUB_NAV_LINK,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_SUB_NAV_LINK,
    pageCategory: 'Offers',
    pageAction: `Offers - Sub Nav - Clicked "${itemName.toUpperCase()}"`,
  }),
  [gtmEventTypes.EXPAND_ACCORDION]: ({
                                       modelName, bodyGradeTitle, offerPrice, expandedText,
                                     }) => ({
    type: gtmEventTypes.EXPAND_ACCORDION,
    event: 'reactjs.event',
    eventID: gtmEventTypes.EXPAND_ACCORDION,
    pageCategory: 'Offers',
    pageAction: `Offers - "${modelName.toUpperCase()}/${bodyGradeTitle.toUpperCase()}/${offerPrice}" - "${expandedText}"`,
  }),
  [gtmEventTypes.COLLAPSE_ACCORDION]: ({
                                         modelName,
                                         bodyGradeTitle,
                                         offerPrice,
                                         collapsedText,
                                       }) => ({
    type: gtmEventTypes.COLLAPSE_ACCORDION,
    event: 'reactjs.event',
    eventID: gtmEventTypes.COLLAPSE_ACCORDION,
    pageCategory: 'Offers',
    pageAction: `Offers - "${modelName.toUpperCase()}/${bodyGradeTitle.toUpperCase()}/${offerPrice}" - "${collapsedText}"`,
  }),
  [gtmEventTypes.CLICK_CTA]: ({
                                modelName, bodyGradeTitle, offerPrice, ctaLabel,
                              }) => ({
    type: gtmEventTypes.CLICK_CTA,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_CTA,
    pageCategory: 'Offers',
    pageAction: `Offers - "${modelName.toUpperCase()}/${bodyGradeTitle.toUpperCase()}/${offerPrice}" - Clicked CTA - "${ctaLabel.toUpperCase()}"`,
  }),
  [gtmEventTypes.CLICK_RECOMMENDED_CONTENT]: ({sectionTitle, tileTitle, tileLabel}) => ({
    type: gtmEventTypes.CLICK_RECOMMENDED_CONTENT,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_RECOMMENDED_CONTENT,
    pageCategory: 'Offers',
    pageAction: `Offers - "${sectionTitle.toUpperCase()}" - Clicked "${tileTitle.toUpperCase()}" - "${tileLabel.toUpperCase()}"`,
  }),
}



// WEBPACK FOOTER //
// ./src/store/gtm-events/offers-duck.js